<template>
  <div style="padding: 20px 0px 0px 20px;">

    <el-form style="display: flex;flex-wrap: wrap;" >

       <el-form-item label="订单号:" style="display: flex;width: 15%;" >
          <el-input style="width: 65%;" v-model="name1" placeholder="请输入订单号"></el-input>
      </el-form-item>


      <el-form-item label="城市:" style="display: flex;width: 15%;">
        <el-select placeholder="请选择城市" v-model="name2" style="width: 65%" clearable filterable>
           <el-option v-for="item in listSelect1" :key="item.id" :label="item.dictValue"  :value="item.dictType"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="学生姓名:" style="display: flex;width: 15%;">
        <el-input v-model="name3" placeholder="请输入学生姓名" clearable style="width: 65%;" ></el-input>
      </el-form-item>


       <el-form-item label="年级:" style="display: flex;width: 15%;">
         <el-cascader clearable v-model="name4" :options="listSelect2" :props="props" style="width: 65%;" ></el-cascader>
      </el-form-item>

      <el-form-item label="销售:" style="display: flex;width: 15%;">
        <el-select placeholder="请选择销售" v-model="name5" style="width: 65%" clearable filterable>
          <el-option v-for="item in listSelect3" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="学生类型:" style="display: flex;width: 15%;">
        <el-select placeholder="请选择学生类型" v-model="name6" style="width: 65%" clearable filterable>
          <el-option v-for="item in listSelect4" :key="item.id" :label="item.dictValue"  :value="item.dictType"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="来源:" style="display: flex;width: 15%;">
        <el-select placeholder="请选择来源" v-model="name7" style="width: 65%" clearable filterable>
          <el-option v-for="item in listSelect5" :key="item.sourceId" :label="item.sourceName" :value="item.sourceId"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="付款渠道:" style="display: flex;width: 15%;">
        <el-select placeholder="请选择付款渠道" v-model="name8" style="width: 65%" clearable filterable>
          <el-option v-for="item in listSelect6" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="客资类型:" style="display: flex;width: 15%;">
        <el-select placeholder="请选择客资类型" v-model="name9" style="width: 65%" clearable filterable>
          <el-option v-for="item in listSelect7" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="收支类型:" style="display: flex;width: 15%;">
        <el-select placeholder="请选择收支类型" v-model="name10" style="width: 65%" clearable filterable>
          <el-option v-for="item in listSelect8" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="诊断师:" style="display: flex;width: 15%;">
        <el-select v-model="searchSource22" clearable filterable   placeholder="请选择是否结清" style="width: 65%">
          <el-option v-for="item in sources22" :key="item.teacherId" :label="item.teacherName" :value="item.teacherId"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="规划师:" style="display: flex;width: 15%;">
        <el-select v-model="searchSource222" clearable filterable   placeholder="请选择是否结清" style="width: 65%">
          <el-option v-for="item in sources222" :key="item.teacherId" :label="item.teacherName" :value="item.teacherId"></el-option>
        </el-select>
      </el-form-item>



      <el-form-item label="创建时间:" style="display: flex;width: 100%;">
        <el-date-picker v-model="name11" type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"></el-date-picker>
      </el-form-item>



<!--  <el-form-item label="项目名称:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择审批状态" v-model="input3" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item> -->

     <div style="display: flex;width: 100%;margin-left: 70px;">
        <div style="display: flex;width: 50%;margin-top: 10px;margin-bottom: 30px;">
         
              <div
               style=" font-weight: 900;
                width: 200px;
                background-color: rgb(150 233 149);
                height: 30px;
                border-radius: 10px;
                padding: 5px 0px;
                margin-bottom: 10px;
                text-align: start;
                line-height: 26px;
                padding-left: 10px;
                padding-left: 17px;
                "
               > 收入：{{ incomeMoney }} </div>


               <div
                 style="
                   font-weight: 900;
                   width: 200px;
                   background-color: #c2f54b;
                   height: 30px;
                   border-radius: 10px;
                   padding: 5px 0px;
                   margin-bottom: 10px;
                   text-align: start;
                   line-height: 26px;
                   padding-left: 10px;
                   margin-left: 100px;
                   padding-left: 17px;
                 "
               > 支出：{{ expendMoney }} </div>
        </div>

        <div style="display: flex;justify-content: end;width: 50%;margin-top: 10px;margin-bottom: 30px;">
          <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus"  @click="searchAddBtns">添加</el-button> -->
          <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
          <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"   @click="searchBtns">搜索</el-button>
          <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"   @click="clearBtns">清空</el-button>
        </div>
     </div>

    </el-form>


    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"  :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700"  >
       <!-- show-summary :summary-method="getSummaries"  :span-method="tableSpanMethod"   -->
        
      <el-table-column prop="customerId" label="订单号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="regionName" label="城市" show-overflow-tooltip></el-table-column>
      <el-table-column prop="studentName" label="学生姓名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="gradeName" width="180" label="年级" show-overflow-tooltip></el-table-column>
      <el-table-column prop="saleName" label="销售" show-overflow-tooltip></el-table-column>
      <el-table-column prop="diagnoseTeacherName" label="诊断师"></el-table-column>
      <el-table-column prop="projectTeacherName" label="规划师"></el-table-column>
      <el-table-column prop="classTypeName" label="学生类型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="customerSourceName" label="来源" show-overflow-tooltip></el-table-column>
      <el-table-column prop="payAlltypeName" width="200" label="付款渠道" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sumMoney" width="130" label="金额" show-overflow-tooltip></el-table-column>
      <el-table-column prop="costTypeName" label="客资类型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="periodsNumber" label="期数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="incomeTypeName" label="收支类型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" width="200" label="创建时间" show-overflow-tooltip></el-table-column>
   
    </el-table>

    <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
      :page-size="pageSize" layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>
    

    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" :title="Titlecenter" :visible="addShow" :before-close="closeEditDialog" width="80%">

      <el-form style=""   :disabled="ishowoTypeDisabled">

        <el-form-item label="老师:" style="width: 100%;">
          <el-select placeholder="请选择老师" v-model="input11" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="部门:" style="width: 100%;">
          <el-select style="width: 100%" v-model="resumeNumber33" popper-class="tree-select-popper"  ref="treeSelect2">
              <el-option hidden :value="resumeNumber33"> </el-option>
              <el-tree
                  :data="dataTrees"
                  :props="defaultPropss"
                  node-key="deptId"
                  ref="treeSelect2"
                  :highlight-current="true"
                  :check-on-click-node="true"
                  @check="handleTreeChecks">
              </el-tree>
          </el-select>
        </el-form-item>


        <el-form-item label="兑换礼品:" style="width: 100%;">
          <el-select placeholder="请选择兑换礼品" v-model="input3333" style="width: 100%" clearable filterable>
            <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所需积分:" style="width: 100%;">
          <el-input v-model="input333333" placeholder="请输入所需积分"></el-input>
        </el-form-item>



        <el-form-item label="兑换日期:" style="width: 100%;">
          <el-date-picker v-model="input2222" type="date" style="width: 100%;" value-format="yyyy-MM-dd" placeholder="请选择日期" clearable></el-date-picker>
        </el-form-item>

      </el-form>


    <div style="display: flex; margin-bottom: 20px; justify-content: end;">
      <el-button  type="primary" size="small" class="btns"  v-if="!ishowoTypeDisabled"  @click="handleClickViewBtn('保存')">保存</el-button>
      <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('取消')">取消</el-button>
    </div>


    </el-dialog>

  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { getTeachers } from "@/api/fiveClassApi"


export default {
  components: {

  },
  data() {
    return {

      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },

      ishowoTypeDisabled: false,

      value1: '',
      value2: [],
      value3: [],

      integralCount: 0,


      input33:'',
      input333:'',



      inputValue1: '',
      inputValue2: 0 ,
      inputValue3: '',

      Titlecenter: '添加积分项目',
      optionList4: [{ id: 0, name: '无效' }, { id: 1, name: '有效' }],

      optionList1: [],
      optionList2: [],
      optionList3: [{ id: 0, name: '待审批' }, { id: 1, name: '驳回' }, { id: 2, name: '已完成' }],

      input1: '',
      input2: [],
      input3: '',

      dataList: [],

      pageNum: 1,
      pageSize: 10,
      total: 0,


      pageNum1: 1,
      pageSize1: 10,
      total1: 0,

      CourseCancellationComponentsType: '',
      CourseCancellationComponentsID: '',
      CourseCancellationComponentsShow: false,

      CourseCancellationomponentsTypeDistinguish: '课消审批',

      dataList1:[],


      addShow: false,

      inputID:'',

      optionList5:[],
      teacherIditme:null,


      resumeNumber3Id:'',
      resumeNumber3:'',

      dataTrees:[],
      defaultPropss:{ children: 'children', label: 'deptName' }, 


      input11:'',
      resumeNumber33:'',
      resumeNumber33Id:'',
      input3333:'',
      input333333:'',
      input2222:'',

      summaryData: {
        teacherId: 0, // 金额
      },




      listSelect1:[],
      listSelect2:[],
      listSelect3:[],
      listSelect4:[
        {dictValue:"规划", dictType:1 },
        {dictValue:"线下", dictType:2 },
        {dictValue:"纯补课", dictType:3 },
      ],
      listSelect5:[],
      listSelect6:[
        {
            value: 1,
            label: "现金"
          },
          {
            value: 2,
            label: "微信"
          },
          {
            value: 3,
            label: "支付宝"
          },
          {
            value: 4,
            label: "银行卡"
          },
          {
            value: 5,
            label: "公户"
          },
          {
            value: 6,
            label: "小鹅通"
          }
          ,{
            value: 7,
            label: "美团"
          }
           ,{
            value: 8,
            label: "公户（桑穆）"
          }
           ,{
            value: 9,
            label: "公户（博川）"
          },
          {
            value: 10,
            label: "公户（蒙正心理）"
          },
      ],
      listSelect7:[
        { realname:'全款' , id:'1' ,},
        { realname:'分期' , id:'2' ,},
        { realname:'续费' , id:'3' ,},
        { realname:'退费' , id:'4' ,},
        { realname:'定金' , id:'0' ,},

      ],
      listSelect8:[
        { realname:'收入' , id:'1' ,},
        { realname:'支出' , id:'2' ,}
      ],


      name1:'',
      name2:'',
      name3:'',
      name4: [],
      name5:'',
      name6:'',
      name7:'',
      name8:'',
      name9:'',
      name10:'',
      name11: [],


      searchSource22:'',
      searchSource222:'',

      sources22:[],
      sources222:[],

      incomeMoney: 0,
      expendMoney: 0,


    }
  },

  created(){
        this.getApiList()
  },

  mounted() {
    getTeachers().then(res => { this.optionList1 = res.data })
    axios.get(`${apiBaseUrl}/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.optionList2 = res.data.data })
    axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTrees = res.data.data})
    axios.get(`${apiBaseUrl}/teacher/teacherSale`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.listSelect3 = res.data.data})
    
    this.sources222 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
    this.sources22 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))

    this.listSelect6 = JSON.parse(sessionStorage.getItem('payTypesList'))


    this.handleintegralProject()

    this.getcityOptions();

    setTimeout(() => {
      this.$nextTick(() => {
         this.getApiList();
      });
    }, 0);

  },


  methods: {

    

    getcityOptions(){

      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ 
        this.listSelect1 = res.data.data
      })


      axios.get(`${apiBaseUrl}/grade/getGrade`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        this.listSelect2 = res.data.data;
      }).catch(error => {
        this.$message({ message: error,  type: "error"  });
      })


      axios.get(`${apiBaseUrl}/customerinformation/sourcelist`,{headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
        this.listSelect5 = response.data.data.list;
      })
      .catch((error) => {
        console.error(error);
      });


    },

    handleTreeCheck(e){
      this.resumeNumber3 = e.deptName
      this.resumeNumber3Id = e.deptId
      this.$refs.treeSelect1.visible = false
    },


    handleTreeChecks(e){
      this.resumeNumber33 = e.deptName
      this.resumeNumber33Id = e.deptId
      this.$refs.treeSelect2.visible = false
    },

    handleintegralProject(){
      axios.post(`${apiBaseUrl}/integralProject/findList`, { integralName:'' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.optionList5 = data
        } else {
          this.optionList5 = []
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleClickViewBtn(type){


      if(type === '保存'){
        this.$message.success('保存成功')
        this.addShow = false
        this.input11 = ''
        this.resumeNumber33 = ''
        this.input3333 = ''
        this.input333333 = ''
        this.input2222 = ''
      }

      if(type === '取消'){
          this.inputValue1 = ''
          this.inputValue2 = 0
          this.inputValue3 = ''
          this.Titlecenter = ''
          this.inputID = ''
          this.addShow = false

          this.input11 = ''
          this.resumeNumber33 = ''
          this.input3333 = ''
          this.input333333 = ''
          this.input2222 = ''

      }

      if(type === '确定'){

        if(this.inputValue1 === ''){
          this.$message.warning('请输入项目名称')
          return
        }

        if(this.inputValue3 === ''){
          this.$message.warning('请选择项目状态')
          return
        }

        let data = {
          name: this.inputValue1,
          score: this.inputValue2,
          status: this.inputValue3,
          id: this.inputID,
        }

      }

    },

    searchAddBtns() {
      this.Titlecenter = '添加积分项目'
      this.addShow = true
      this.ishowoTypeDisabled = false
    },

    closeEditDialog() {
      this.Titlecenter = ''
      this.inputValue1 = ''
      this.inputValue2 = 0
      this.inputValue3 = ''
      this.inputID = ''

      this.value1 = ''
      this.value2 = []
      this.value3 = []

      this.input11 = ''
      this.resumeNumber33 = ''
      this.input3333 = ''
      this.input333333 = ''
      this.input2222 =''


      this.addShow = false
    },

    

       // 合计行内容
    getSummaries({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 8 || column.property === 'sumMoney') {
            sums[index] = '汇总';
          } 
          else if (column.property && this.summaryData[column.property] !== undefined) {
            sums[index] = this.summaryData[column.property];
          } else if (data.length === 0 && index >= 3) {
            // 没有数据时也展示“总计：”
            sums[index] = '';
          } else {
            sums[index] = '';
          }
        });
        return sums;
    },
   
    tableSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 最后一行（合计行）合并前3列
      if (rowIndex === this.dataList.length && columnIndex === 0) {
        return [1, 10]; // 合并1行3列
      }
      if (rowIndex === this.dataList.length && (columnIndex === 1 ||  columnIndex === 2)) {
        return [0, 0]; // 被合并的单元格
      }
    },



    CourseCancellationhandleEmit(e) {
      this.CourseCancellationComponentsShow = e
    },

    searchBtns() {
      this.getApiList()
    },

    searchBtns1() {
      this.getApiList1()
    },

    clearBtns1() {
      this.value1 = ''
      this.value2 = []
      this.value3 = []
      this.getApiList1()
    },


    clearBtns() {
      this.searchSource22 = ''
      this.searchSource222 = ''
      this.name1 = ''
      this.name2 = ''
      this.name3 = ''
      this.name4 = []
      this.name5 = ''
      this.name6 = ''
      this.name7 = ''
      this.name8 = ''
      this.name9 = ''
      this.name10 = ''
      this.name11 = []

      this.input1 = ''
      this.input2 = []
      this.input3 = ''
      this.input4 = ''
      this.input33 = ''
      this.input333 = ''
      this.resumeNumber3 = ''

      this.pageNum = 1
      this.pageSize = 10

      this.getApiList()
    },

    exportBtns(){
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        customerId: this.name1,
        regionName: this.name2,
        studentName: this.name3,
        grade: this.name4.length > 0 ? JSON.stringify(this.name4) : '',
        saleId: this.name5,
        classType: this.name6,
        customerSource: this.name7,
        payAlltype: this.name8,
        costType: this.name9,
        incomeType: this.name10,
        createTimeStart: this.name11.length > 0 ? this.name11[0] + ' 00:00:00' : null,
        createTimeEnd: this.name11.length > 0 ? this.name11[1] + ' 23:59:59' : null,
        projectTeacherId: this.searchSource222,
        diagnoseTeacherId: this.searchSource22,
      }
      axios.post(`${apiBaseUrl}/customerInformationIncome/excelFirstFeedback`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
           if(response.status == 200){
               const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
               const downloadLink = document.createElement("a")
               downloadLink.href = URL.createObjectURL(blob)
               downloadLink.download = "收支管理.xlsx"
               downloadLink.click()
               this.$message({ message:'导出成功', type: "success" });
           } else{
              this.$message.error('导出失败')
           }
       }).catch((err) => {
          this.$message.error(err)
      })
    },


    getApiList1() {
      let data = {
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        teacherId: this.teacherIditme.teacherId,
        commitStartDate: (this.value2 && this.value2.length > 0) ? this.value2[0] + ' 00:00:00' : null,
        commitEndDate: (this.value2 && this.value2.length > 0) ? this.value2[1] + ' 00:00:00' : null,
        auditStartDate: (this.value3 && this.value3.length > 0) ? this.value3[0] + ' 00:00:00' : null,
        auditEndDate: (this.value3 && this.value3.length > 0) ? this.value3[1] + ' 00:00:00' : null,
        integralId: this.value1,
      }
      axios.post(`${apiBaseUrl}/integralAudit/findTeacherIntegralPage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList1 = data.records.records
          this.pageNum1= data.records.current ? data.records.current : 1
          this.pageSize1 = data.records.size ? data.records.size : 10
          this.total1 = data.records.total ? data.records.total : 0
          this.integralCount = data.integralCount

          if(data.records && data.records.records.length < 0){
            this.dataList1 = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {

          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    getApiList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        customerId: this.name1,
        regionName: this.name2,
        studentName: this.name3,
        grade: this.name4.length > 0 ? JSON.stringify(this.name4) : null,
        saleId: this.name5,
        classType: this.name6,
        customerSource: this.name7,
        payAlltype: this.name8,
        costType: this.name9,
        incomeType: this.name10,
        createTimeStart: this.name11.length > 0 ? this.name11[0] + ' 00:00:00' : null,
        createTimeEnd: this.name11.length > 0 ? this.name11[1] + ' 23:59:59' : null,
        projectTeacherId: this.searchSource222,
        diagnoseTeacherId: this.searchSource22,
      }




      axios.post(`${apiBaseUrl}/customerInformationIncome/findCount`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if(res.data.code === 200){
          this.incomeMoney = res.data.data.incomeMoney
          this.expendMoney = res.data.data.expendMoney
        }else{
          this.incomeMoney = 0
          this.expendMoney = 0
        }
      }).catch((err) => {
         this.message.error(err)
         this.incomeMoney = 0
         this.expendMoney = 0
      })



      axios.post(`${apiBaseUrl}/customerInformationIncome/find`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data

          // let obj = { sumMoney: data.records.length > 0 ? "汇总：1999" : "" }

          let arr = data.records
          // arr.push(obj)
          this.dataList = arr

          this.pageNum = data.current ? data.current : 0
          this.pageSize = data.size ? data.size : 10
          this.total = data.total ? data.total : 0

          if(data.records && data.records.length < 0){
            this.dataList = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleSizeChange(e) {
      this.pagepageSizeNum = e
      this.getApiList()
    },

    handleSizeChange1(e) {
      this.pageSize1 = e
      this.getApiList1()
    },


 


    handleCurrentChange(e) {
      this.pageNum = e
      this.getApiList()
    },


    handleCurrentChange1(e) {
      this.pageNum1= e
      this.getApiList1()
    },

    handleClickView(type, itme) {
      
      let data = {
        deptId: "1817500568573329408",
        deptName: "测试部门",
        teacherId:3,
        gift: 3,
        points: 3,
        Time: "2023-10-01 00:00:00",
      }

      this.input11 = data.teacherId
      this.resumeNumber33Id = data.deptId
      this.resumeNumber33 = data.deptName
      this.input3333 = data.gift
      this.input333333 = data.points
      this.input2222 = data.Time


      if (type === '编辑') {
        console.log(itme)
        this.ishowoTypeDisabled = false
        this.Titlecenter = '编辑积分项目'

        this.inputValue1 = itme.inputValue1
        this.inputValue2 = itme.inputValue2
        this.inputValue3 = itme.inputValue3
        this.inputID = itme.id

        this.addShow = true

      }

      if (type === '详情') {
        console.log(itme)
        this.Titlecenter = '积分详情'
        this.ishowoTypeDisabled = true

        this.teacherIditme = itme

        this.addShow = true

        this.getApiList1()


      } 
      if (type === '删除') {
         console.log(itme)
        // 提示二次删除确认
        this.$confirm('确定删除该条信息吗?, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 发送删除请求
          axios.post(`${apiBaseUrl}/`, { id: itme.id }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
            if (res.data.code === 200) {
              this.$message({ message: res.data.message, type: "success" });
              this.getApiList()
            } else {
              this.$message.error(res.data.message)
            }
          }).catch((err) => {
            this.$message.error(err)
          })
        })


      }


    },


  }

}
</script>


<style scoped lang="less">
.no-click {
  pointer-events: none;
}

/deep/ .el-form-item__content{
  margin-left: -36px !important;
}

/deep/ .el-form-item__label{
  width: 100px !important;
}

/deep/ .el-range-editor{
   margin-left: 36px !important;
}
</style>



// WEBPACK FOOTER //
// src/RevenueAndManagementAll/RevenueAndManagement.vue